(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4858],{

/***/ 8525:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/login",
      function () {
        return __webpack_require__(26800);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97997);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11720);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_sanity__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98107);
/* harmony import */ var _components_layout_app__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77854);
/* harmony import */ var _components_seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93304);
/* harmony import */ var _components_shared_loader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(18668);








function filterDataToSingleItem(data, preview) {
    if (!Array.isArray(data)) {
        return data;
    }
    if (data.length === 1) {
        return data[0];
    }
    if (preview) {
        return data.find(function(item) {
            return item._id.startsWith("drafts.");
        }) || data[0];
    }
    return data[0];
}
var __N_SSG = true;
function Page(param) {
    var data = param.data, preview = param.preview;
    var ref, ref1, ref2, ref3;
    var ref4;
    var ref5 = (0,_lib_sanity__WEBPACK_IMPORTED_MODULE_4__/* .usePreviewSubscription */ .$r)(data === null || data === void 0 ? void 0 : data.query, {
        params: (ref4 = data === null || data === void 0 ? void 0 : data.queryParams) !== null && ref4 !== void 0 ? ref4 : {},
        initialData: data === null || data === void 0 ? void 0 : data.page,
        enabled: preview
    }), previewData = ref5.data;
    var page = filterDataToSingleItem(previewData, preview);
    var appPage = (page === null || page === void 0 ? void 0 : page.appPages) || null;
    var siteSettings = (page === null || page === void 0 ? void 0 : page.siteSettings) || null;
    var siteNav = (page === null || page === void 0 ? void 0 : page.siteNav) || null;
    var topNav = (page === null || page === void 0 ? void 0 : page.topNav) || null;
    var topFooterNav = (page === null || page === void 0 ? void 0 : page.topFooterNav) || null;
    var bottomFooterNav = (page === null || page === void 0 ? void 0 : page.bottomFooterNav) || null;
    var contentComponentHero = (page === null || page === void 0 ? void 0 : (ref = page.appPages) === null || ref === void 0 ? void 0 : ref.contentComponentHero) || null;
    var contentComponents = (page === null || page === void 0 ? void 0 : (ref1 = page.appPages) === null || ref1 === void 0 ? void 0 : ref1.contentComponents) || null;
    var appAccessLevel = (page === null || page === void 0 ? void 0 : (ref2 = page.appPages) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.appAccess) === null || ref3 === void 0 ? void 0 : ref3.accessLevel) || "anonymous";
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    if (!router.isFallback && !(appPage === null || appPage === void 0 ? void 0 : appPage.slug)) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
            statusCode: 404
        });
    }
    if (router.isFallback) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_shared_loader__WEBPACK_IMPORTED_MODULE_7__/* .Loader */ .a, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_seo__WEBPACK_IMPORTED_MODULE_6__/* .SEO */ .H, {
                page: appPage,
                site: siteSettings,
                path: appPage === null || appPage === void 0 ? void 0 : appPage.slug
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_components_layout_app__WEBPACK_IMPORTED_MODULE_5__/* .Layout */ .A, {
                preview: preview,
                asPath: "contact",
                siteNav: siteNav,
                topNav: topNav,
                topFooterNav: topFooterNav,
                bottomFooterNav: bottomFooterNav,
                siteSettings: siteSettings,
                contentComponents: contentComponents,
                contentComponentHero: contentComponentHero,
                appAccessLevel: appAccessLevel
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6556,5445,6914,4617,1228,7010,1180,9471,5546,8115,8552,7279,4670,5624,6730,44,6466,7854,9774,2888,179], function() { return __webpack_exec__(8525); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);